import React, { useEffect } from 'react';
import './Footer.css';
import { Link, useLocation } from "react-router-dom";
import { FaLinkedinIn, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const location = useLocation();

  // Scroll to top when Home is clicked
  useEffect(() => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <footer className="footer">
      <div className="footer-width footer-container">

        {/* Company Info Section */}
        <div className="footer-section company-info">
          <Link to="/" className="footer-logo" onClick={() => window.scrollTo(0, 0)}>
            <img src="/logo-light.png" alt="Data Bolta Hai Logo" />
          </Link>
          <p>
            Our Goal Is To Help Our Companies Maintain Achieve Best Class Positions
            In Their Respective Industries & Our Team Works Occur That Works Have To Be Repudiated.
          </p>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/data-bolta-hai/posts/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.youtube.com/@databoltahi6388" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Company Column */}
        <div className="footer-section">
          <h3>Company</h3>
          <ul>
            <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About</Link></li>
            <li><Link to="/careers" onClick={() => window.scrollTo(0, 0)}>Careers</Link></li>
            <li><Link to="/blog" onClick={() => window.scrollTo(0, 0)}>Blog</Link></li>
            <li><Link to="/about#team-section" onClick={() => window.scrollTo(0, 0)}>Our Team</Link></li>
          </ul>
        </div>

        {/* Solutions Column */}
        <div className="footer-section">
          <h3>Solutions</h3>
          <ul>
            <li><Link to="/services/artificial-intelligence-intelligent-automation" onClick={() => window.scrollTo(0, 0)}>AI & Intelligent Automation</Link></li>
            <li><Link to="/services/gst-reconciliation" onClick={() => window.scrollTo(0, 0)}>GST Reconciliation</Link></li>
            <li><Link to="/services/stock-market-data-analysis" onClick={() => window.scrollTo(0, 0)}>Stock Market Analysis</Link></li>
            <li><Link to="/services/bank-narration-intelligence" onClick={() => window.scrollTo(0, 0)}>Bank Narration Intelligence</Link></li>
            <li><Link to="/services/dpdp-compliance" onClick={() => window.scrollTo(0, 0)}>DPDP & Data Privacy</Link></li>
            <li><Link to="/services/call-centre-customer-service-automation" onClick={() => window.scrollTo(0, 0)}>Customer Service Automation</Link></li>
            <li><Link to="/services/digital-marketing-customer-engagement" onClick={() => window.scrollTo(0, 0)}>Digital Marketing</Link></li>
            <li><Link to="/services/automation-process-digitisation-mis" onClick={() => window.scrollTo(0, 0)}>Process Digitisation</Link></li>
          </ul>
        </div>

        {/* Resources Column */}
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><Link to="/media" onClick={() => window.scrollTo(0, 0)}>Media</Link></li>
            <li><Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>Contact</Link></li>
            <li><Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>FAQs</Link></li>
           
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section contact-info">
          <h3>Contact Us</h3>
          <p><FaMapMarkerAlt />320 Dimple Arcade, Thakur Complex, Kandivali East, 400101</p>
          <p><FaPhoneAlt /> +91 70215-20017</p>
          <p><FaEnvelope /> info@databoltahi.com</p>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <div className="footer-width footer-bottom-inner">
          <p>© <span>Data Bolta Hai</span>. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;